import { createClient, type SupabaseClient } from "@supabase/supabase-js";

// Browser client. Uses the publishable key only — never a secret/service key
// (CLAUDE.md: no service_role in frontend code). RLS does the authorization.
//
// Without VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY the app runs in
// demo mode: no login, sample data. Useful for previews before a database
// is attached.

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined;

export const supabase: SupabaseClient | null =
  url && key
    ? createClient(url, key, {
        auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
      })
    : null;

export const isDemoMode = supabase === null;

/** True when pointing at a local Supabase stack (shows the seed login hint). */
export const isLocalSupabase = !!url && /localhost|127\.0\.0\.1/.test(url);
